import React from 'react'

const EmailIcon = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.0185 2.01492C1.68356 2.08975 1.36358 2.22034 1.07193 2.40123C0.568058 2.73354 0.178155 3.3058 0.0557861 3.89245C-0.0185954 4.25116 -0.0185954 18.9091 0.0557861 19.2678C0.244139 20.1676 1.01315 20.9366 1.91292 21.1249C2.27283 21.1993 21.7272 21.1993 22.0871 21.1249C22.5398 21.021 22.954 20.7916 23.2825 20.4632C23.6109 20.1348 23.8402 19.7205 23.9442 19.2678C24.0186 18.9091 24.0186 4.25116 23.9442 3.89245C23.7787 3.09945 23.2064 2.44681 22.3894 2.1217L22.1015 2.00652L12.12 2.00053C6.63014 1.99813 2.08448 2.00412 2.0185 2.01492M21.5232 4.42272C20.0158 5.37557 18.505 6.32294 16.9908 7.26481C13.616 9.37148 12.4427 10.0805 12.2519 10.1297C12.0883 10.1837 11.9117 10.1837 11.7481 10.1297C11.5573 10.0805 10.384 9.37148 7.00925 7.26481C5.49499 6.32294 3.98416 5.37557 2.47678 4.42272C2.45159 4.39993 6.73692 4.38193 12 4.38193C17.2631 4.38193 21.5484 4.39993 21.5232 4.42272M6.93967 10.2173C9.41465 11.7637 11.5249 13.0594 11.6293 13.0966C11.8691 13.1817 12.1309 13.1817 12.3707 13.0966C12.4751 13.0594 14.5854 11.7637 17.0603 10.2173C18.5627 9.2741 20.0688 8.33672 21.5784 7.40518C21.5892 7.40518 21.5976 9.96414 21.5976 13.0918V18.7783H2.4024V13.0918C2.4024 9.96414 2.4108 7.40518 2.42159 7.40518C2.43239 7.40518 4.46588 8.67086 6.93967 10.2173"
        clipRule="evenodd"
        fillRule="evenodd"
      />
    </svg>
  )
}

export default EmailIcon
